import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { ContentSlotListItem } from './ContentListItem/ContentSlotListItem.js';
import { InteractiveListItem } from './InteractiveListItem/InteractiveListItem.js';
import { State } from './ListItem.types.js';
import { useListItem } from './useListItem.js';

var _excluded = ["disabled", "containerBoxProps", "listItemBoxProps", "href", "listItemProps", "role", "p"];
var ListItemV2 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useListItem = useListItem(props),
    disabled = _useListItem.disabled,
    containerBoxProps = _useListItem.containerBoxProps,
    listItemBoxProps = _useListItem.listItemBoxProps,
    href = _useListItem.href,
    listItemProps = _useListItem.listItemProps,
    role = _useListItem.role,
    p = _useListItem.p,
    remainingProps = _objectWithoutProperties(_useListItem, _excluded);
  return /*#__PURE__*/React.createElement(InteractiveListItem, _extends({
    borderRadius: props.borderRadius,
    p: p,
    role: role,
    disabled: disabled,
    ref: ref,
    href: href,
    title: listItemProps.title
  }, containerBoxProps, remainingProps), /*#__PURE__*/React.createElement(ContentSlotListItem, _extends({}, listItemBoxProps, listItemProps)));
});
ListItemV2.defaultProps = {
  p: '12',
  gap: '12',
  borderRadius: '2',
  type: {
    type: 'item'
  },
  state: State.enabled,
  role: 'listitem'
};
var ListItemV2Memoized = /*#__PURE__*/React.memo(ListItemV2);

export { ListItemV2 as BaseListItemV2Element, ListItemV2Memoized as ListItemV2 };
//# sourceMappingURL=ListItemV2.js.map
